var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm.isAuthenticated
        ? _c(
            "div",
            [
              _c("AppHeader"),
              _c(
                "section",
                { staticClass: "navbar-space no-padding" },
                _vm._l(_vm.fakeFeed, function(feed, index) {
                  return _c("feed-item", { key: index, attrs: { feed: feed } })
                }),
                1
              ),
              _c("AppFooter")
            ],
            1
          )
        : _vm._e(),
      !_vm.isAuthenticated && _vm.authStatus !== "loading"
        ? _c("div", [_c("FirstPageReg")], 1)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }